/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Faq_A5Inputs */

const en_cad_faq_a5 = /** @type {(inputs: Cad_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Through an MCP server (cadcraft-cli mcp), a JSON control channel on the running app, or the headless command-line tool. Agents can run commands, query entities, inspect the drawing and render images to check their work.`)
};

/**
* | output |
* | --- |
* | "Through an MCP server (cadcraft-cli mcp), a JSON control channel on the running app, or the headless command-line tool. Agents can run commands, query entiti..." |
*
* @param {Cad_Faq_A5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_faq_a5 = /** @type {((inputs?: Cad_Faq_A5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Faq_A5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_faq_a5(inputs)
});
export { cad_faq_a5 as "cad.faq.a5" }